import React, { useEffect, useRef, useState } from "react";
import { CgClose } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { authService } from "../../../services/authService";
import { fetchCountries } from "../../../store/actions";
import { setGiftDelivery } from "../../../store/slices/modalSlice";
import { addressDescriptionValidator } from "../../../core/helpers";

import { toast } from "react-hot-toast";

const DeliveryAddressPopover = ({ onClose, handleOrder }) => {
  const dispatch = useDispatch();
  const { fetchCountriesData } = useSelector((state) => state.masterData);
  const { giftDelivery } = useSelector((state) => state.modal);

  const [fetchedCountries, setFetchedCountries] = useState();
  const [countries, setCountries] = useState();
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedAreaId, setSelectedAreaId] = useState(
    (giftDelivery && giftDelivery?.selectedAreaId) || ""
  );
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const [addr1, setAddr1] = useState(
    (giftDelivery && giftDelivery?.addr1) || ""
  );
  const [addr2, setAddr2] = useState(
    (giftDelivery && giftDelivery?.addr2) || ""
  );
  const [landmark, setLandmark] = useState(
    (giftDelivery && giftDelivery?.landmark) || ""
  );
  const [zipcode, setZipcode] = useState(
    (giftDelivery && giftDelivery?.zipcode) || ""
  );
  const [phone, setPhone] = useState(giftDelivery && giftDelivery?.phone);
  const [valid, setValid] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    selectedAreaId: "",
    addr1: "",
    phone: "",
  });

  // Address 1
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const options = {
    componentRestrictions: { country: "ng" },
    fields: ["address_components", "geometry", "icon", "name"],
    types: ["establishment"],
  };
  useEffect(() => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );

    autoCompleteRef.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef.current.getPlace();
      setAddr1(place?.name);
    });
  }, [options]);

  const verification_code = authService.getCurrentUserVerificationCode();
  const userId = authService.getCurrentUserID();

  const handleChangeEvent = (e) => {
    setPhone(e.target.value.replace(/[^0-9]/g, ""));
  };

  useEffect(() => {
    if (!fetchCountriesData) {
      const data = {
        sql_ref_no: "12",
        user_id: userId?.toString(),
        c_code: verification_code,
        option: "19",
      };

      dispatch(fetchCountries(data));
    }

    if (fetchCountriesData)
      setFetchedCountries(fetchCountriesData.location_info);
  }, [fetchCountriesData, userId, verification_code, dispatch]);

  useEffect(() => {
    if (fetchedCountries) {
      const resArr = [];
      fetchedCountries.filter((item) => {
        let i = resArr.findIndex((x) => x === item.country_name);
        if (i <= -1) {
          resArr.push(item.country_name);
        }
        return null;
      });

      setCountries(resArr);
    }
  }, [fetchedCountries]);

  useEffect(() => {
    if (selectedAreaId && addr1 && addr2 && landmark && zipcode) setValid(true);
  }, [selectedAreaId, addr1, addr2, landmark, zipcode]);

  const getCities = (count) => {
    const cities = [];
    fetchedCountries.filter((item) => {
      if (item.country_name === count) {
        cities.push(item);
      }
      return null;
    });

    const resArr = [];
    cities.filter((item) => {
      let i = resArr.findIndex((x) => x === item.city_name);
      if (i <= -1) {
        resArr.push(item.city_name);
      }
      return null;
    });

    return resArr;
  };

  const getAreas = (cit) => {
    const areas = [];
    fetchedCountries.filter((item) => {
      if (item.city_name === cit) {
        areas.push(item);
      }
      return null;
    });

    return areas;
  };

  const handleChange = (event) => {
    setSelectedCountry(event.target.value);
    const selectedCities = getCities(event.target.value);
    setCities(selectedCities);
  };

  const handleChangeArea = (event) => {
    setSelectedState(event.target.value);
    const selectedAreas = getAreas(event.target.value);

    setAreas(selectedAreas);
  };

  const handleChangeAreaID = (event) => {
    setSelectedAreaId(event.target.value.split("-")[0]);
    setSelectedAreaName(event.target.value.split("-")[1]);
  };

  const payloadValuesError = addressDescriptionValidator(
    addr1,
    phone,
    selectedAreaId
  );

  const handleNext = (e) => {
    try {
      e.preventDefault();

      if (Object.keys(payloadValuesError).length) {
        toast.error("Please Fill required fields ...");
        return setErrorMsg({
          ...errorMsg,
          addr1: payloadValuesError.addr1,
          phone: payloadValuesError.phone,
          selectedAreaId: payloadValuesError.areaId,
        });
      }

      const deliveryData = {
        selectedAreaId,
        selectedAreaName,
        addr1,
        addr2,
        landmark,
        zipcode,
        country: selectedCountry,
        city: selectedState,
        phone,
      };

      dispatch(setGiftDelivery(deliveryData));
      handleOrder();
    } catch (err) {
      return err;
    }
  };

  return (
    <div className="mt-28 h-min px-2 xsm:px-4">
      <div className="w-full max-w-md rounded-2xl bg-white px-3 py-3 text-gray-500 xsm:px-6 xsm:py-4">
        <div className="flex items-center justify-between">
          <div className="font-semibold text-gray-600 sm:text-xl">
            Delivery Address (2/3)
          </div>
          <button
            onClick={() => {
              onClose();
            }}
            className="rounded-full p-1 hover:bg-gray-100 active:bg-gray-200"
          >
            <CgClose className="h-5 w-5 text-gravel-500" />
          </button>
        </div>
        <div className="mt-1 flex justify-start text-[11px] xsm:text-xs">
          Please enter your gift recipient’s delivery address
        </div>
        <div>
          <form>
            <div className="mt-3">
              <label
                htmlFor="country/region"
                className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
              >
                Country/Region
              </label>
              <div className="relative flex items-center justify-end rounded-md">
                <div className="flex-grow">
                  <select
                    onChange={handleChange}
                    type="text"
                    className="block w-full cursor-pointer rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm focus:border-olivine-500 focus:ring-olivine-500"
                  >
                    {giftDelivery &&
                    giftDelivery?.country &&
                    giftDelivery?.country ? (
                      <option>{giftDelivery?.country}</option>
                    ) : (
                      <option>select</option>
                    )}
                    {countries &&
                      countries.map((country, idx) => (
                        <option key={idx} value={country}>
                          {country}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-3 flex items-start space-x-2 sm:space-x-3">
              <div className="flex-1">
                <label
                  htmlFor="selectState"
                  className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
                >
                  State
                </label>
                <div className="relative flex items-center justify-end rounded-md">
                  <div className="flex-grow">
                    <select
                      onChange={handleChangeArea}
                      type="text"
                      className="block w-full cursor-pointer rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm focus:border-olivine-500 focus:ring-olivine-500"
                    >
                      {giftDelivery &&
                      giftDelivery?.city &&
                      giftDelivery?.city ? (
                        <option>{giftDelivery?.city}</option>
                      ) : (
                        <option>select</option>
                      )}
                      {cities &&
                        cities.map((city, idx) => (
                          <option key={idx} value={city}>
                            {city}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <label
                  htmlFor="area"
                  className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
                >
                  Area <span className="text-rose-600"> * </span>
                </label>
                <div className="relative flex items-center justify-end rounded-md">
                  <div className="flex-grow" id="myDropdown">
                    <select
                      onChange={handleChangeAreaID}
                      id="myInput"
                      type="text"
                      className="block w-full cursor-pointer rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm focus:border-olivine-500 focus:ring-olivine-500"
                    >
                      {giftDelivery &&
                      giftDelivery?.selectedAreaName &&
                      giftDelivery?.selectedAreaName ? (
                        <option>{giftDelivery?.selectedAreaName}</option>
                      ) : (
                        <option>select</option>
                      )}
                      {areas &&
                        areas.map((area, idx) => (
                          <option
                            key={idx}
                            value={`${area.area_id}-${area.area_name}`}
                          >
                            {area.area_name}
                          </option>
                        ))}
                    </select>

                    {errorMsg?.selectedAreaId ? (
                      <span className="ml-3 text-xs text-red-500">
                        {errorMsg?.selectedAreaId}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <label
                htmlFor="addressLine1"
                className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
              >
                Address Line 1 <span className="text-rose-600"> * </span>
              </label>
              <div className="relative flex items-center justify-end rounded-md">
                <div className="flex-grow">
                  <input
                    onChange={(e) => {
                      const limit = 50;

                      // 👇️ only take first N characters
                      setAddr1(e.target.value.slice(0, limit));
                    }}
                    value={addr1}
                    type="text"
                    ref={inputRef}
                    placeholder="House/Flat No, Street/Road name"
                    className="block w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                  />

                  {errorMsg?.addr1 ? (
                    <span className="ml-3 text-xs text-red-500">
                      {errorMsg?.addr1}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="mt-3">
              <label
                htmlFor="addressLine2"
                className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
              >
                Address Line 2
              </label>
              <div className="relative flex items-center justify-end rounded-md">
                <div className="flex-grow">
                  <input
                    onChange={(e) => {
                      const limit = 50;

                      // 👇️ only take first N characters
                      setAddr2(e.target.value.slice(0, limit));
                    }}
                    value={addr2}
                    type="text"
                    placeholder=""
                    className="block w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 flex items-start space-x-2 sm:space-x-3">
              <div className="flex-1">
                <label
                  htmlFor="landmark"
                  className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
                >
                  Landmark
                </label>
                <div className="relative flex items-center justify-end rounded-md">
                  <div className="flex-grow">
                    <input
                      onChange={(e) => {
                        const limit = 50;

                        // 👇️ only take first N characters
                        setLandmark(e.target.value.slice(0, limit));
                      }}
                      value={landmark}
                      type="text"
                      placeholder="Landmark"
                      className="block w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <label
                  htmlFor="zipCode"
                  className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
                >
                  Postal Code
                </label>
                <div className="relative flex items-center justify-end rounded-md">
                  <div className="flex-grow">
                    <input
                      onChange={(e) => {
                        const limit = 6;

                        // 👇️ only take first N characters
                        setZipcode(
                          e.target.value.replace(/[^0-9]/g, "").slice(0, limit)
                        );
                      }}
                      value={zipcode}
                      type="text"
                      placeholder="Enter Zip Code"
                      className="block w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <label
                htmlFor="phoneNumber"
                className="mb-[2px] ml-2 flex justify-start text-xs font-medium text-gray-600"
              >
                Phone Number <span className="text-rose-600"> * </span>
              </label>
              <div className="relative flex items-center justify-end rounded-md">
                <div className="flex-grow">
                  <input
                    onChange={handleChangeEvent}
                    value={phone}
                    type="text"
                    placeholder="Enter Phone Number"
                    className="block w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-sm text-gray-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                  />
                  {errorMsg?.phone ? (
                    <span className="ml-3 text-xs text-red-500">
                      {errorMsg?.phone}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
          <div className="mt-5 flex justify-between pb-4 text-center tracking-widest">
            <button
              onClick={() => onClose()}
              className="rounded-md border-[1px] border-olivine-500  px-6 py-2.5 text-sm text-olivine-500 transition duration-300 hover:bg-olivine-100 active:ring-1 active:ring-olivine-500 sm:px-8"
            >
              BACK
            </button>
            <button
              onClick={handleNext}
              // disabled={!valid}
              className="rounded-md bg-olivine-500 px-8 py-2.5 text-sm text-white transition duration-300 hover:bg-olivine-400 active:bg-olivine-600 disabled:opacity-30 disabled:hover:bg-olivine-500 sm:px-10"
            >
              NEXT
            </button>
            {/* <button
              disabled={!valid}
              onClick={handleNext}
              className="rounded-md bg-olivine-500 px-8 py-2 text-sm font-semibold  text-white transition duration-300 hover:bg-olivine-600 sm:px-10"
            >
              
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryAddressPopover;
